import { ICompany, TTerm } from "./types"

type boxContentType = {[index: string]:{
  size: string,
  cubic: string,
  door: string,
  storeIn: string[],
  advantage: string
}}

export const termData:TTerm[] = [
  {name: '1 месяц', count: 1, discount: 0},
  {name: '2 месяца', count: 2, discount: 0},
  {name: '3 месяца', count: 3, discount: 3},
  {name: '6 месяцев', count: 6, discount: 5},
  {name: '12 месяцев', count: 12, discount: 7}
]

export const boxContent: boxContentType = {
  '1,5': {
    size: '1x1,3x2,1',
    cubic: '2,8м3',
    door: '1x2',
    storeIn: ['сезонные и детские вещи', 'автомобильные колеса', 'детские коляски', 'мелкогабаритная мебель', 'бытовая техника', 'инструменты', 'лыжи', 'сноуборды', 'ролики', 'скейтборды', 'самокаты', 'гироскутеры', 'некрупный спорт инвентарь'],
    advantage: 'Идеально подойдет тогда, когда необходимо избавиться от части неиспользуемых вещей',
  },
  '2,5': {
    size: '1,9x1,3x2,1',
    cubic: '5,2 м3',
    door: '1x2',
    storeIn: ['коробки с вещами', 'автомобильные запчасти', 'садовый инвентарь', 'средняя бытовая техника', 'велосипеды', 'крупные чемоданы', 'строительные материалы', 'небольшие шкафы', 'тренажеры'],
    advantage: 'Главное преимущество данной ячейки — длина почти два метра'
  },
  '3,1': {
    size: '2,2 x 1,4 x 2,1',
    cubic: '6 м3',
    door: '0,82x2,05',
    storeIn: ['мебельные комплекты', 'стиральные машины', 'холодильники', 'обогреватели', 'садовая мебель', 'байдарки', 'газонокосилки', 'стеллажи с инструментами'],
    advantage: 'Главное преимущество данной ячейки — длина больше двух метров',
  },
  '4': {
    size: '2 x 2 x 2,1',
    cubic: '8,5 м3',
    door: '0,92x2,05',
    storeIn: ['диваны', 'крупные шкафы', 'кровати', 'мягкие кресла', 'кухонные гарнитуры', 'мотоциклы', 'большие велосипеды', 'груды коробок с книгами', 'сезонные шины для авто'],
    advantage: '',
  },
  '6,2': {
    size: '2,2 x 2,8 x 2,1',
    cubic: '13 м3',
    door: '0,92x2,05',
    storeIn: ['половина содержимого квартиры', 'диваны', 'кровати', 'гардеробы', 'крупная бытовая техника', 'строительные материалы', 'большие спортивные тренажеры', 'полный комплект мебели для гостиной'],
    advantage: '',
  },
  '7,5': {
    size: '2,8 х 2,4 х 2,4',
    cubic: '18 м3',
    door: '1х2,05',
    storeIn: ['полное содержимое двухкомнатной квартиры', 'крупная мебель', 'длинные стеллажи с инструментами', 'мотоциклы', 'крупные садовые инструменты', 'лыжные комплекты'],
    advantage: '',
  },
  '8': {
    size: '4х2х2,1',
    cubic: '17 м3',
    door: '1х2,05',
    storeIn: ['содержимое трехкомнатной квартиры', 'крупные бытовые приборы', 'строительная техника', 'садовая техника', 'паллеты с вещами', 'лодки', 'небольшой автомобиль'],
    advantage: '',
  },
  '14,2': {
    size: '5,9 x 2,4 x 2,4',
    cubic: '34м3',
    door: '2x2',
    storeIn: ['мебель и техника для офиса или большой квартиры', 'небольшие катера', 'мебельные гарнитуры', 'паллеты с материалами', 'крупная строительная техника', 'тяжелая садовая техника'],
    advantage: 'Подходит для склада под бизнес, переезда или любых других личных нужд',
  },
  '15': {
    size: '5,9 х 2,4 х 2,4',
    cubic: '36м3',
    door: '2x2',
    storeIn: ['содержимое большой квартиры или небольшого дома', 'лодки', 'квадроциклы', 'крупногабаритная мебель', 'строительная и садовая техника', 'небольшие фургоны'],
    advantage: 'Подходит для склада под бизнес, переезда или любых других личных нужд',
  },
  '30': {
    size: '12 х 2,4 х 2,5',
    cubic: '75м3',
    door: '2x2',
    storeIn: ['содержимое частного дома', 'небольшой автомобиль', 'катер', 'мотоциклы', 'крупная техника для производства', 'большие строительные материалы', 'полный переезд офиса', 'машинное оборудование'],
    advantage: 'Подходит для склада под бизнес, переезда или любых других личных нужд',
  }
}



export const dataCompany: ICompany = window._dataCompany ? JSON.parse(window._dataCompany) : null